import React from 'react';
import { useResizeObserver } from '@isyc-react/core/resize-observer';
export let Observed = /*#__PURE__*/function (Observed) {
  Observed[Observed["HEIGHT"] = 0] = "HEIGHT";
  Observed[Observed["WIDTH"] = 1] = "WIDTH";
  Observed[Observed["HEIGHT_WIDTH"] = 2] = "HEIGHT_WIDTH";
  return Observed;
}({});
export const ResizeObserved = props => {
  const {
    children,
    onChange,
    type = Observed.HEIGHT_WIDTH
  } = props;
  const {
    ref,
    height,
    width
  } = useResizeObserver();
  React.useEffect(() => {
    if (type === Observed.WIDTH && width && onChange) onChange({
      height: 0,
      width
    });
  }, [width]);
  React.useEffect(() => {
    if (type === Observed.HEIGHT && height && onChange) onChange({
      height,
      width: 0
    });
  }, [height]);
  React.useEffect(() => {
    if (type === Observed.HEIGHT_WIDTH && height && width && onChange) onChange({
      height,
      width
    });
  }, [height, width]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children);
};